module.exports = __webpack_public_path__ + "static/Stocksy_man-910725d960d21d60f8b6de52b167dd03.jpg";